// extracted by mini-css-extract-plugin
module.exports = {"fallback":"Image_fallback___Wnz2","fill":"Image_fill__AqpH0","icon":"Image_icon__X_e4J","label":"Image_label__qHnIo"};